<!-- 艺术品推荐 -->
<template>
  <div class="Showcases fd_column">
    <div class="m-b-30">
      <div class="title_mid">
        <img src="@/assets/home/Groupsh.png" alt="" />
        <div @click="toRouterPush('/Showcases')" class="more">
          <div>VIEW MORE</div>
          <img src="@/assets/home/arrow-right-up-line.png" alt="" />
        </div>
      </div>
    </div>
    <div class="component_box longhair" v-if="windowWidth > 1024">
      <div class="section2">
        <div
          class="swiper1-container"
          @mouseover="stopAutoplay"
          @mouseout="startAutoplay"
        >
          <!-- 轮播容器，鼠标移入时停止自动播放，移出时开始自动播放 -->
          <div
            class="swiper1"
            :style="{
              transform: slideTransform,
              transitionDuration: transitionDuration,
            }"
          >
            <!-- 轮播图，应用平移变换和过渡持续时间 -->
            <div
              class="swiper1-item"
              v-for="(item, index) in extendedSwiperData"
              :key="index"
              @mouseover="hoverItem(index, item.id)"
              @mouseout="hoverItem(-1)"
              @click="linkJump(1, '/ShowcasesDetail', { id: item.id })"
              :class="{ active: index === currentHoverIndex }"
            >
              <!-- 轮播项，鼠标移入时调用hoverItem方法，移出时调用hoverItem方法并传入-1，应用active -->
              <div
                class="swiper-slide"
                :style="{
                  backgroundImage: 'url(' + $baseImgUrl + item.headImg + ')',
                }"
              >
                <div class="blue_mark"></div>
                <div class="longhair_artistName">
                  <div class="loaction">
                    <img
                      class="start loca-img"
                      src="@/assets/home/Vector.png"
                      alt=""
                      v-if="currentHoverIndex !== index"
                    />
                    <img
                      v-else
                      class="start_active loca-img"
                      src="@/assets/home/active-Vector.png"
                      alt=""
                    />
                    <div class="countryName">{{ item.countryName }}</div>
                    <div
                      :style="{
                        '--bg-image': 'url(' + businessTypeNameBg + ')',
                        '--bg-color': item.theValue,
                      }"
                      class="businessTypeImg"
                    >
                      {{ item.businessTypeName }}
                    </div>
                  </div>
                  <div class="artistName">{{ item.theName }}</div>
                  <div class="industryName">
                    <div class="industryNameboxbox">
                      <div
                        :style="{
                          '--tag-count':
                            item.industryName &&
                            Array.isArray(item.industryName)
                              ? item.industryName.length
                              : 0,
                          'animation-duration':
                            item.industryName &&
                            Array.isArray(item.industryName)
                              ? (100 / 18) * item.industryName.length + 's'
                              : '0s',
                        }"
                        :class="{
                          iftumble:
                            item.industryName &&
                            Array.isArray(item.industryName) &&
                            item.industryName.length > 1,
                        }"
                        class="boxbox"
                      >
                        <div
                          v-for="i in item.industryName &&
                          Array.isArray(item.industryName)
                            ? item.industryName
                            : []"
                          :key="i"
                          class="industryNamelabel"
                        >
                          <div>
                            {{ i }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <img
                      class="start start-img"
                      src="@/assets/home/start.png"
                      alt=""
                      v-if="currentHoverIndex !== index"
                    />
                    <img
                      v-else
                      class="start start-img"
                      src="@/assets/home/start_active.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div @mouseover="stopAutoplay" @mouseout="startAutoplay">
        <div @click="handleNext()" class="swiper-button-next1 prev1">
          <span>
            <img src="@/assets/home/button-prev.png" alt="" />
          </span>
        </div>
        <div @click="handlePrev()" class="swiper-button-prev1 next1">
          <span>
            <img src="@/assets/home/button-next.png" alt="" />
          </span>
        </div>
      </div>
    </div>
    <div v-else>
      <van-swipe
        :autoplay="3000"
        loop
        :show-indicators="false"
        indicator-color="#164099"
      >
        <van-swipe-item
          v-for="(item, index) in listData"
          :key="index"
          @click="linkJump(1, '/ShowcasesDetail', { id: item.id })"
        >
          <div class="longhair_artistName">
            <div class="loaction">
              <img
                class="start loca-img"
                src="@/assets/home/Vector.png"
                alt=""
              />
              <div class="countryName">{{ item.countryName }}</div>
              <div
                :style="{
                  '--bg-image': 'url(' + businessTypeNameBgM + ')',
                  '--bg-color': item.theValue,
                }"
                class="businessTypeImg"
              >
                {{ item.businessTypeName }}
              </div>
            </div>
            <div class="artistName">{{ item.theName }}</div>
            <div class="industryName">
              <div class="industryNameboxbox">
                <div
                  :style="{
                    '--tag-count':
                      item.industryName && Array.isArray(item.industryName)
                        ? item.industryName.length
                        : 0,
                    'animation-duration':
                      item.industryName && Array.isArray(item.industryName)
                        ? (100 / 18) * item.industryName.length + 's'
                        : '0s',
                  }"
                  :class="{
                    iftumble:
                      item.industryName &&
                      Array.isArray(item.industryName) &&
                      item.industryName.length > 1,
                  }"
                  class="boxbox"
                >
                  <div
                    v-for="i in item.industryName &&
                    Array.isArray(item.industryName)
                      ? item.industryName
                      : []"
                    :key="i"
                    class="industryNamelabel"
                  >
                    <div>
                      {{ i }}
                    </div>
                  </div>
                </div>
              </div>
              <img
                class="start start-img"
                src="@/assets/home/start.png"
                alt=""
              />
            </div>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { showcasesgetList } from "@/api/Home/Home";
import "swiper/css/swiper.css";
export default {
  // import引入的组件需要注入到对象中才能使用
  data() {
    // 这里存放数据
    return {
      imgApi: process.env.VUE_APP_BASE_IMAGE,
      isActive: null,
      subActive: null,
      listData: [],
      swiper: null,
      swipersize: null,
      slidesOffsetBefore: null,
      windowWidth: null,
      currentSlide: 0, // 当前的轮播索引
      autoplayInterval: null,
      currentHoverIndex: -1, // 当前悬停的索引
      transitionDuration: "0.5s", // 过渡时长
      businessTypeNameBg: require("@/assets/showcases/Rectangle.png"),
      businessTypeNameBgM: require("@/assets/showcases/RectangleM.png"),
    };
  },
  // 监听属性 类似于data概念
  computed: {
    // 克隆前后的数据来实现无缝无限滚动
    extendedSwiperData() {
      if (
        !this.listData ||
        !Array.isArray(this.listData) ||
        this.listData.length === 0
      ) {
        return [];
      }
      const extendedData = [
        ...this.listData, // 原始数据
        ...this.listData.slice(0, 4), // 克隆最前面的4个
      ];
      // 确保克隆的数据也有正确的shouldScroll属性
      extendedData.forEach((item, index) => {
        if (index >= this.listData.length) {
          const originalIndex = index - this.listData.length;
          item.shouldScroll = this.listData[originalIndex].shouldScroll;
          item.tagRef = this.listData[originalIndex].tagRef;
        }
      });
      return extendedData;
    },
    // 计算当前的平移量
    slideTransform() {
      return `translateX(${this.currentSlide * -25}%)`;
    },
  },
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    handleScroll() {
      this.windowWidth = window.innerWidth;
      this.windowWidth > 1024 ? (this.swipersize = 4) : (this.swipersize = 1);
      this.windowWidth > 1024
        ? (this.slidesOffsetBefore = -545)
        : (this.slidesOffsetBefore = 1);

      // 窗口大小改变时重新检查标签宽度
      this.checkTagsWidth();
    },
    async getList() {
      const res = await showcasesgetList();
      if (res.code === 1) {
        this.listData = res.data || [];
        if (Array.isArray(this.listData)) {
          this.listData.forEach((item) => {
            item.tagRef = null;
            item.shouldScroll = false;
            // 确保 industryName 存在且为字符串
            if (item.industryName && typeof item.industryName === "string") {
              item.industryName = item.industryName.split(".");
            } else {
              item.industryName = [];
            }
          });
          if (this.listData.length >= 4) {
            this.$nextTick(() => {
              // 确保DOM更新后再初始化Swiper
              if (this.windowWidth > 1024) {
                this.startAutoplay();
              }
              this.checkTagsWidth();
            });
          }
        }
      }
    },
    checkTagsWidth() {
      if (!this.listData || !this.listData.length) return;

      // 使用setTimeout确保DOM完全渲染
      setTimeout(() => {
        this.listData.forEach((item) => {
          if (!item.tagRef) {
            return;
          }

          const wrapper = item.tagRef.closest(".industryNamelabel");
          if (!wrapper) {
            return;
          }

          // 获取实际内容宽度
          const tempSpan = document.createElement("span");
          tempSpan.style.visibility = "hidden";
          tempSpan.style.position = "absolute";
          tempSpan.style.whiteSpace = "nowrap";
          tempSpan.style.fontSize = window.getComputedStyle(
            item.tagRef
          ).fontSize;
          tempSpan.style.fontFamily = window.getComputedStyle(
            item.tagRef
          ).fontFamily;
          tempSpan.style.fontWeight = window.getComputedStyle(
            item.tagRef
          ).fontWeight;
          tempSpan.textContent = item.industryName;
          document.body.appendChild(tempSpan);

          const tagWidth = tempSpan.offsetWidth;
          const wrapperWidth = wrapper.offsetWidth;

          // 移除临时元素
          document.body.removeChild(tempSpan);

          // 使用Vue.set确保响应式更新
          this.$set(item, "shouldScroll", tagWidth > wrapperWidth - 5);

          // 强制更新DOM
          this.$forceUpdate();
        });

        // 强制更新extendedSwiperData
        this.$forceUpdate();
      }, 200);
    },
    // 每隔2秒轮播
    startAutoplay() {
      // 先清除可能存在的定时器
      this.stopAutoplay();
      this.autoplayInterval = setInterval(() => {
        this.nextSlide();
      }, 4000);
    },
    stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    },
    //自动轮播
    nextSlide() {
      if (this.currentSlide === this.listData.length) {
        // 当滑动到克隆的最后一张时，瞬时跳到真正的第一张
        this.transitionDuration = "0s"; // 取消动画，瞬时跳转
        this.currentSlide = 0;
        setTimeout(() => {
          this.transitionDuration = "0.5s"; // 恢复动画
          this.currentSlide = 1; // 跳到第一个真实的 slide
        }, 50); // 延迟一点点再恢复动画
      } else {
        this.currentSlide++;
      }
    },
    // 鼠标悬停
    hoverItem(index) {
      this.currentHoverIndex = index;
    },
    //前进
    handleNext() {
      // 停止自动轮播
      this.stopAutoplay();
      if (this.currentSlide === this.listData.length) {
        this.transitionDuration = "0s";
        this.currentSlide = 0;
        setTimeout(() => {
          this.transitionDuration = "0.5s";
          this.currentSlide = 1;
        }, 50);
      } else {
        this.currentSlide++;
      }
    },
    //后退
    handlePrev() {
      // 停止自动轮播
      this.stopAutoplay();
      if (this.currentSlide === 0) {
        this.transitionDuration = "0s";
        this.currentSlide = this.listData.length;
        setTimeout(() => {
          this.transitionDuration = "0.5s";
          this.currentSlide = this.listData.length - 1;
        }, 50);
      } else {
        this.currentSlide--;
      }
    },
    // 处理窗口切换
    handleVisibilityChange() {
      if (document.hidden) {
        // 窗口隐藏时停止轮播
        this.stopAutoplay();
      } else {
        // 窗口显示时重新开始轮播
        this.startAutoplay();
      }
    },
    //vant swiper change
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getList();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.handleScroll();
    window.addEventListener("resize", this.handleScroll);
    // 添加窗口切换监听
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {
    window.removeEventListener("resize", this.handleScroll);
    // 移除窗口切换监听
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange
    );
    //离开清除
    this.stopAutoplay();
  },
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
// @import url(); 引入公共css类
@import "~@/static/styles/variables.less";
@import "~@/static/styles/index.less";
</style>

<style lang="less" scoped>
@media screen and (min-width: 750px) {
  @import "./ShowcasesPc.less";
}
@media screen and (max-width: 750px) {
  @import "./ShowcasesMo.less";
}
</style>

<style lang="less">
// .van-swipe__track {
//   gap: 0.5333rem;
// }
</style>
